import React, {Dispatch} from "react"
import Modal from "../Modal"
import {useFormik} from "formik"
import Input from "../../../generic/dataEntry/Input/Input"
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux"
import classes from "../Modal/Modal.module.scss"
import {changePassword} from "../../../../store/actions/authActions"
import {authSlice} from "../../../../store/slices/authSlice"

interface IModalChangePasswordProps {
  modalToggle: Dispatch<any>
  changeSuccess: Dispatch<any>
}

function ModalChangePassword({modalToggle, changeSuccess}: IModalChangePasswordProps) {

  const dispatch = useAppDispatch()
  const {error} = useAppSelector(state => state.auth)

  const initialFormValues = {
    old_password: "",
    new_password: "",
    new_password_confirm: ""
  }

  const {values, touched, handleChange, handleReset} = useFormik({
    initialValues: initialFormValues,
    onSubmit: () => {}
  })

  const saveHandler = async () => {

    dispatch(authSlice.actions.clearError())

    const errors = []

    if (!values.old_password) {
      errors.push({field: "old_password", message: "Введите старый пароль"})
    }

    if (!values.new_password) {
      errors.push({field: "new_password", message: "Введите новый пароль"})
    }

    if (!values.new_password_confirm) {
      errors.push({field: "new_password_confirm", message: "Введите повтор нового пароля"})
    }

    if (!errors.length) {
      const isPasswordUpdated = await dispatch(changePassword(values))

      if (isPasswordUpdated) {
        modalToggle(false)
        changeSuccess(true)
        dispatch(authSlice.actions.clearError())
        handleReset(initialFormValues)
      }
    } else {
      dispatch(authSlice.actions.fieldError(errors))
    }
  }

  const inputChangeHandler = (e: React.ChangeEvent) => {
    handleChange(e)
    const fieldName: any = e.target.getAttribute('name')

    if (error[fieldName]) {
      dispatch(authSlice.actions.clearFieldError(fieldName))
    }
  }

  const closeHandler = () => {
    modalToggle(false)
    dispatch(authSlice.actions.clearError())
  }

  return (
    <Modal
      title={"Смена пароля"}
      close={closeHandler}
      dialogSizeSuffix={"w435"}
      submitClick={saveHandler}
      cancelClick={closeHandler}
      headerAlignCenter
    >
      <form
        className={classes.form}
      >
        <div className={classes.form_field}>
          <Input
            type={"password"}
            value={values.old_password}
            onChange={(e: React.ChangeEvent) => {
              inputChangeHandler(e)
            }}
            name={"old_password"}
            label={"Старый пароль"}
            valid={!error.old_password}
            errorMessage={error.old_password}
            touched={touched.old_password}
            shouldValidate
            required
          />
        </div>
        <div className={classes.form_field}>
          <Input
            type={"password"}
            value={values.new_password}
            onChange={(e: React.ChangeEvent) => {
              inputChangeHandler(e)
            }}
            name={"new_password"}
            label={"Новый пароль"}
            valid={!error.new_password}
            errorMessage={error.new_password}
            touched={touched.new_password}
            shouldValidate
            required
          />
        </div>
        <div className={classes.form_field}>
          <Input
            type={"password"}
            value={values.new_password_confirm}
            onChange={(e: React.ChangeEvent) => {
              inputChangeHandler(e)
            }}
            name={"new_password_confirm"}
            label={"Повторите новый пароль"}
            valid={!error.new_password_confirm}
            errorMessage={error.new_password_confirm}
            touched={touched.new_password_confirm}
            shouldValidate
            required
          />
        </div>
      </form>
    </Modal>
  )
}

export default ModalChangePassword